// Aviso FIJO mientras Contablus espera una respuesta del SRI por el portal:
// anular un comprobante, reportar una anulacion o consultar su estado.
//
// El desenlace llega por WebSocket y el portal puede tardar un par de minutos. El
// toast de antes se cerraba solo a los 8 s y dejaba al usuario sin ninguna senal de
// que el proceso seguia, lo que lo empujaba a reintentar o a irse. Este queda en
// pantalla hasta que llega el resultado (clearSriPendingToast) o, si el WebSocket
// nunca responde, hasta el tope de espera: ahi se cambia por un aviso de que la
// operacion sigue en el servidor.
//
// Va en un grupo propio porque PrimeVue 3 no sabe quitar un toast puntual, solo
// grupos: cada formulario que lo usa monta <Toast group="sriPending"/>.

export const SRI_PENDING_TOAST_GROUP = 'sriPending';

// Tope duro de las tareas del portal (SRI_PORTAL_HARD_LIMIT, 165 s) con margen.
export const SRI_PENDING_MAX_WAIT_MS = 180000;

export const SRI_PENDING_STAY_MESSAGE = 'No cierres esta ventana hasta obtener la respuesta.';

// Un solo aviso a la vez: el portal atiende una operacion por negocio.
let timeoutHandle = null;

export function showSriPendingToast(toast, { summary, detail, onTimeout = null }) {
    clearSriPendingToast(toast);
    toast.add({
        severity: 'info',
        group: SRI_PENDING_TOAST_GROUP,
        summary,
        detail: [detail, SRI_PENDING_STAY_MESSAGE].filter(Boolean).join(' '),
    });
    timeoutHandle = setTimeout(() => {
        timeoutHandle = null;
        toast.removeGroup(SRI_PENDING_TOAST_GROUP);
        toast.add({
            severity: 'warn',
            summary: 'El SRI está tardando',
            detail: 'La operación sigue en curso. Recarga la página en unos minutos para ver el resultado.',
            life: 12000,
        });
        if (onTimeout) { onTimeout(); }
    }, SRI_PENDING_MAX_WAIT_MS);
}

export function clearSriPendingToast(toast) {
    if (timeoutHandle !== null) {
        clearTimeout(timeoutHandle);
        timeoutHandle = null;
    }
    toast.removeGroup(SRI_PENDING_TOAST_GROUP);
}
